import { Application } from "@hotwired/stimulus"

let Stimulus

if (!Stimulus) {
  Stimulus = Application.start()
}

export default Stimulus
